module.exports = __webpack_public_path__ + "static/media/bicon.39c08d2c.svg";